// extracted by mini-css-extract-plugin
export default {"ServerError":"ServerError_ServerError__b+b-3"};